import { ExtraOptions, Routes, PreloadAllModules, PreloadingStrategy, Route } from '@angular/router';
import { Observable, of } from 'rxjs';

export class CustomPreloader implements PreloadingStrategy {
    preload(route: Route, load: () => Observable<any>): Observable<any> {
        return route.data && route.data.preload ? load() : of(null);
    }
}

export const RouterOptions: ExtraOptions = {
  initialNavigation: 'enabledBlocking',
  preloadingStrategy: CustomPreloader,
  scrollPositionRestoration: 'disabled'
};

export const routes: Routes = [];

export const environment = {
    production: true,
    hmr: false,
    frontendUrl: 'https://www.expometals.net',
    backendUrl: 'https://www.expometals.net/graphql',
    googleMapsKey: 'AIzaSyB3B6gUafbkZV5h4peNK0cuYHL5wA6bvsU',
    googleClientID: '942106285688-p4mtiemp4n1vfl752p0qo8rrofq8ni63.apps.googleusercontent.com',
    GTM_Id: 'GTM-TJLDVRZ',
    GA4_id: 'G-K31PWK9RSQ',
    cookie: {
      domain: 'expometals.net',
      secure: true
    },
    enableMetaTagRobots: true,
    debugOn: false,
    gtmserv: 'https://gtm.expometals.net',
    tinyMce: '/lib/tinymce/tinymce.min.js',
    BACKEND_TIMEOUT: 1000*60,
    BACKEND_TIMEOUT_SSR: 1000*6 // 6 secondi di timeout in production lato ssr (da verificare)
};
